import chroma from 'chroma-js';

export function updateCssVariables(value) {

    const root = document.documentElement;
   
    const {
        primaryColor = '#212427', // Default to black
        secondaryColor = '#212427', // Default to white
        accentColor = '#212427'
    } = value;
        
    const primaryContrastColor = getContrastColor(primaryColor);
   
    root.style.setProperty('--primary-color', primaryColor);
    root.style.setProperty('--secondary-color', secondaryColor);
    root.style.setProperty('--accent-color', accentColor);
    root.style.setProperty('--primary-contrast-color', primaryContrastColor);
}

function getContrastColor(color) {
    return chroma.contrast(color, 'white') > chroma.contrast(color, 'black') ? '#FFFFFF' : '#000000';
}